import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.83833} fill="#E7EBFA" />
    <G clipPath="url(#clip0_1120_7781)">
      <Path
        opacity={0.2}
        d="M18.479 27.4791L14.5209 23.521L12.7959 28.2676C12.7477 28.3984 12.7381 28.5403 12.768 28.6765C12.798 28.8127 12.8663 28.9374 12.9649 29.036C13.0635 29.1346 13.1882 29.2029 13.3244 29.2329C13.4606 29.2628 13.6025 29.2532 13.7334 29.2051L18.479 27.4791Z"
        fill="#1434CB"
      />
      <Path
        opacity={0.2}
        d="M16.321 18.571L23.4292 25.6791L27.2729 24.2822C27.3886 24.2403 27.4918 24.17 27.5729 24.0776C27.6541 23.9852 27.7106 23.8738 27.7373 23.7538C27.7639 23.6337 27.7598 23.5088 27.7254 23.3908C27.6909 23.2727 27.6272 23.1653 27.5401 23.0785L18.9217 14.4647C18.8348 14.3779 18.7274 14.3143 18.6095 14.28C18.4916 14.2456 18.3669 14.2416 18.2469 14.2682C18.127 14.2949 18.0158 14.3513 17.9235 14.4324C17.8312 14.5134 17.7608 14.6164 17.7189 14.7319L16.321 18.571Z"
        fill="#1434CB"
      />
      <Path
        d="M12.796 28.2675L17.7189 14.7319C17.7607 14.6162 17.8311 14.513 17.9235 14.4318C18.0159 14.3507 18.1273 14.2941 18.2473 14.2675C18.3674 14.2408 18.4922 14.2449 18.6103 14.2794C18.7283 14.3139 18.8358 14.3776 18.9226 14.4647L27.5364 23.0784C27.6232 23.1653 27.6867 23.2728 27.721 23.3908C27.7552 23.5088 27.7592 23.6335 27.7325 23.7534C27.7057 23.8733 27.6492 23.9846 27.568 24.0768C27.4869 24.1691 27.3838 24.2394 27.2682 24.2812L13.7326 29.204C13.6019 29.2518 13.4603 29.2612 13.3244 29.2312C13.1885 29.2011 13.064 29.1329 12.9656 29.0345C12.8672 28.9361 12.799 28.8116 12.7689 28.6757C12.7389 28.5398 12.7483 28.3982 12.796 28.2675Z"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.75 15.75C24.75 15.75 24.75 13.5 27 13.5C29.25 13.5 29.25 11.25 29.25 11.25"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22.5 10.5V12.75"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.25 19.5L30.75 21"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.25 16.5L31.5 15.75"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.321 18.5709L23.4292 25.679"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.4791 27.4791L14.521 23.521"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1120_7781">
        <Rect width={24} height={24} fill="white" transform="translate(9 9)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
